import { FC } from 'react';
import { styled } from '@robocorp/theme';
import { Box, Typography } from '@robocorp/components';
import { CellPlaceholder } from './Placeholder';
import TextOverflow from '~/components/TextOverflow';

const Container = styled.span`
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

const RunNumber = styled(Typography)`
  white-space: nowrap;
`;

interface Props {
  text?: string;
  subText?: string;
  number?: number;
  subNumber?: number;
}

export const CellRunDetails: FC<Props> = ({ text, subText, number, subNumber }) => {
  if (!text) {
    return <CellPlaceholder />;
  }

  return (
    <Box as="span" display="flex">
      {number !== undefined && (
        <RunNumber as="span" color="content.subtle.light" mr="$4">
          {number}
          {' ·'}
        </RunNumber>
      )}
      <Container>
        <TextOverflow as="span">{text}</TextOverflow>
        <TextOverflow as="span" color="content.subtle.light">
          {subText}
        </TextOverflow>
        {subNumber !== undefined && (
          <Typography as="span" color="content.subtle.light">
            {`‣ #${subNumber}`}
          </Typography>
        )}
      </Container>
    </Box>
  );
};
